module.exports = __webpack_public_path__ + "static/media/md-select-arrow.b6deeb73.svg";